module.exports = __webpack_public_path__ + "static/media/print_02_B.71d75817.png";